import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'ordersReadyToPick';
export const ordersReadyToPickActions = makeActions(MODEL_NAME, 'id', 'orders');

export const getAllOrdersReadyToPick = ordersReadyToPickActions.getAll;
export const editOrdersReadyToPick = ordersReadyToPickActions.edit;
export const createOrdersReadyToPick = ordersReadyToPickActions.create;
export const getByIdOrdersReadyToPick = ordersReadyToPickActions.getDataById;
